module.exports = __webpack_public_path__ + "img/imdb.e1489b03.svg";